import { LIGHT_ORANGE_COLOR, ORANGE_COLOR } from "theme/colors";

export default {
    styleOverrides: {
        indicator: {
            backgroundColor: ORANGE_COLOR,
            transition: "all 500ms ease",
        },
    }
}